import { createFileRoute } from "@tanstack/react-router";

import { supabase } from "@/integrations/supabase/client";
import { routeHead, SITE_URL } from "@/lib/seo-head";
import BlogPost from "@/pages/BlogPost";

export const Route = createFileRoute("/blog_/$slug")({
  loader: async ({ params }) => {
    const { data } = await supabase
      .from("blog_posts")
      .select("title, excerpt, cover_image, meta_title, meta_description, published_at, created_at")
      .eq("slug", params.slug)
      .eq("published", true)
      .or(`published_at.is.null,published_at.lte.${new Date().toISOString()}`)
      .maybeSingle();
    return { post: data };
  },
  head: ({ params, loaderData }) => {
    const post = loaderData?.post;
    if (!post) {
      return routeHead({
        path: `/blog/${params.slug}`,
        title: "Article introuvable | JIIA Studio",
        description: "Cet article n'existe pas ou n'est plus disponible.",
      });
    }

    const url = `${SITE_URL}/blog/${params.slug}`;
    const publishDate = new Date(post.published_at ?? post.created_at);
    const coverUrl = post.cover_image
      ? post.cover_image.startsWith("http")
        ? post.cover_image
        : `${SITE_URL}${post.cover_image}`
      : `${SITE_URL}/og-jiia-studio.jpg`;

    const blogPostingLd = {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      headline: post.title,
      description: post.meta_description || post.excerpt || "",
      image: coverUrl,
      datePublished: publishDate.toISOString(),
      dateModified: post.published_at ?? post.created_at,
      author: { "@type": "Person", name: "Charline Jacob" },
      publisher: {
        "@type": "Organization",
        name: "JIIA Studio",
        url: SITE_URL,
      },
      mainEntityOfPage: { "@type": "WebPage", "@id": url },
      url,
    };

    const breadcrumbLd = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Accueil", item: SITE_URL },
        { "@type": "ListItem", position: 2, name: "Blog", item: `${SITE_URL}/blog` },
        { "@type": "ListItem", position: 3, name: post.title, item: url },
      ],
    };

    return routeHead({
      path: `/blog/${params.slug}`,
      title: post.meta_title || `${post.title} | JIIA Studio`,
      description:
        post.meta_description ||
        post.excerpt ||
        `Lisez l'article "${post.title}" sur le blog de JIIA Studio.`,
      type: "article",
      image: post.cover_image,
      jsonLd: [blogPostingLd, breadcrumbLd],
    });
  },
  component: BlogPost,
});
